// extracted by mini-css-extract-plugin
module.exports = {"h5menuSwitch":"index_h5menuSwitch__H4bbO","menuBtn":"index_menuBtn__tgdqR"};